import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { HeadlineM } from '#src/atoms/typography/index.tsx';
import { Dialog } from '#src/components/dialog/index.tsx';
import { useScreenSize } from '#src/hooks/device/useScreenSize.ts';
import { tabletAndAbove } from '#src/style/mediaQuery.ts';

const SCA_MESSAGE = 'sorare:mangopay:sca-complete';

const Iframe = styled.iframe`
  display: block;
  border: none;
  width: 100%;
  height: 100%;
  margin: auto;

  @media ${tabletAndAbove} {
    width: 500px;
    height: 600px;
    max-width: 100%;
    max-height: 100%;
  }
`;

type Props = {
  url: string;
  onSuccess: () => void;
  onFailed: () => void;
  onClose: () => void;
};

export const MangopayScaIframeDialog = ({
  url,
  onSuccess,
  onFailed,
  onClose,
}: Props) => {
  const { up: isTablet } = useScreenSize('tablet');

  useEffect(() => {
    const cb = (event: MessageEvent) => {
      if (event.data.eventId !== SCA_MESSAGE) return;
      const params = new URL(event.data.data.location).searchParams;
      const controlStatus = params.get('controlStatus');
      if (controlStatus === 'VALIDATED') {
        onSuccess();
      } else if (controlStatus === 'REFUSED' || controlStatus === 'FAILED') {
        onFailed();
      }
    };
    window.addEventListener('message', cb);
    return () => window.removeEventListener('message', cb);
  }, [onSuccess, onFailed]);

  return (
    <Dialog
      open
      disableBackdropClick
      disableEscapeKeyDown
      title={
        <HeadlineM as="h4" className="text-center">
          <FormattedMessage defaultMessage="Account security" />
        </HeadlineM>
      }
      onClose={onClose}
      maxWidth={false}
      fullScreen={!isTablet}
    >
      <Iframe src={url} />
    </Dialog>
  );
};
